// extracted by mini-css-extract-plugin
export default {"content":"AZeQr","code":"_1UU2k","title":"_2tbMs"};